import RoleList from './RoleList';
import RoleCreate from './RoleCreate';
import RoleEdit from './RoleEdit';
import { RoleIcon } from '../../core/themes/icons/RoleIcon';

export default {
  list: RoleList,
  create: RoleCreate,
  edit: RoleEdit,
  icon: RoleIcon
};
